import { sectionTitleSlide } from '../../../../slides/shared/section-title-slide';

export const campaignAnalyticsTitleSlide =
  sectionTitleSlide('Campaign Analytics');
